import { render, staticRenderFns } from "./MiddleYouCanHostUpTo.vue?vue&type=template&id=6c351f1a&scoped=true&"
import script from "./MiddleYouCanHostUpTo.vue?vue&type=script&lang=js&"
export * from "./MiddleYouCanHostUpTo.vue?vue&type=script&lang=js&"
import style0 from "./MiddleYouCanHostUpTo.vue?vue&type=style&index=0&id=6c351f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c351f1a",
  null
  
)

export default component.exports